const { apiGet } = require('./apiClient');

var userData = {};

function initUserData() {
    return apiGet('user/info')
        .then(data => {
            userData = data;
            return Promise.resolve();
        });
}

function getCurrentUserId() {
    if (userData) {
        return userData.id;
    } else {
        return undefined;
    }
}

function getCurrentUserLogin() {
    if (userData) {
        return userData.login;
    } else {
        return undefined;
    }
}

function getRoles() {
    if (userData) {
        return userData.roles || [];
    } else {
        return [];
    }
}

function getCurrentUserCompanyId() {
    if (userData) {
        return userData.companyId;
    } else {
        return undefined;
    }
}

function getCurrentUserAllCompanyIds() {
    if (userData) {
        return userData.companyIds || [];
    } else {
        return [];
    }
}

function getCurrentUserSubCompanyId() {
    if (userData) {
        return userData.subCompanyId;
    } else {
        return undefined;
    }
}

function getJivoToken() {
    if (userData) {
        return userData.jivoToken;
    } else {
        return undefined;
    }
}

function getUserData() {
    return userData;
}

module.exports = {
    initUserData: initUserData,
    getCurrentUserId: getCurrentUserId,
    getCurrentUserLogin: getCurrentUserLogin,
    getRoles: getRoles,
    getCurrentUserCompanyId: getCurrentUserCompanyId,
    getCurrentUserAllCompanyIds: getCurrentUserAllCompanyIds,
    getCurrentUserSubCompanyId: getCurrentUserSubCompanyId,
    getJivoToken: getJivoToken,
    getUserData: getUserData,
};


// WEBPACK FOOTER //
// ./App/services/userRights.js